{
  "common": {
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "secondes",
    "other": "-- Autre --",
    "customFieldExistsError": "Le champ Personnalisée avec ce nom existe déjà",
    "uniqueKeyNotUniqueError": "Cette clé n'est pas unique",
    "save": "Sauvegarder",
    "saving": "Enregistrement",
    "typeAnOption": "Saisir une option",
    "unsaved": "Non enregistré",
    "noSubmissionsFound": "Aucune soumission trouvée",
    "sortBy": "Trier par",
    "clearAll": "Effacer tout",
    "submitSurvey": "Soumettre le sondage",
    "select": "Sélectionner",
    "data"  : "données",
    "disqualifyAfterSubmitLower": "Disqualifier après envoi",
    "errorRetryAgain": "Une erreur s'est produite, veuillez réessayer",
    "bubbleRadioStyleImageAlt": "Style radio bulle",
    "standardRadioStyleImageAlt": "Style radio standard",
    "recurringFrequency": {
      "once": "Une fois",
      "daily": "Par jour",
      "weekly": "Par semaine",
      "monthly": "Mensuel",
      "yearly": "Par an"
    },
    "yes": "Oui",
    "no": "Non",
    "updated": "Mis à jour",
    "new": "Nouveau",
    "title": "Titre",
    "openSettings": "Ouvrir les paramètres",
    "cloneField": "Cloner le champ",
    "removeField": "Supprimer le champ",
    "description": "Description",
    "cannotAddThisField": "Vous ne pouvez pas ajouter ce champ",
    "overallOnly": "Globalement uniquement",
    "nextSlideDefault": "Diapositive suivante (par défaut)",
    "nextQuestion": "Question Suivante",
    "searchAddress": "Rechercher une adresse",
    "recurringDonation": "Don récurrent",
    "recurringDonationDay": "Don récurrent 1 jour",
    "recurringDonationWeek": "Don récurrent 1 semaine",
    "recurringDonationMonth": "Don récurrent 1 mois",
    "recurringDonationYear": "Don récurrent 1 an",
    "integrate": "Intégrer",
    "preview": "Prévisualiser",
    "back": "Retour",
    "alert": "Alerte",
    "proceed": "Poursuivre",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "embed": "Intégrer",
    "link": "Lien",
    "linkModal": {
      "title": "Insérer un lien",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.exemple.com",
      "invalidUrl": "L'URL n'est pas valide"
    },
    "iframeEmbed": "Intégration Iframe",
    "styles": "Styles",
    "options": "Options",
    "quickAdd": "Ajout rapide",
    "customFields": "Champs personnalisés",
    "addObjectFields": "Ajouter des champs d'objet",
    "personalInfo": "Informations personnelles",
    "contactInfo": "Informations du contact",
    "submit": "Envoyer",
    "address": "Adresse",
    "customized": "Personnalisé",
    "layout": "Disposition",
    "showLabel": "Afficher l’étiquette",
    "showImage" : "Afficher l'image",
    "imageLayout" : "Alignement du contenu de l'image",
    "imageLayoutSettings" : "Paramètres de mise en page de l’image",
    "imageLayoutMode" : "Mode de mise en page d'image",
    "surveyDefault" : "Sondage par défaut",
    "independent" : "Indépendamment",
    "image" : "Image",
    "desktop" : "Ordinateur",
    "mobile" : "Mobile",
    "desktopImage" : "Image d’ordinateur",
    "mobileImage" : "Image Mobile",
    "uploaded" : "Téléchargé",
    "changeImage" : "Modifier l'image",
    "uploadImage" : "Télécharger l'image",
    "remove" : "Supprimé",
    "background": "Arrière-plan",
    "buttonBackground": "arrière-plan du bouton",
    "fontColour": "Couleur de la police",
    "textFontColour": "Couleur de la police du texte",
    "subTextFontColour": "Couleur de la police du sous-texte",
    "selectThemes": "thème",
    "selectOne": "Choisissez-en un",
    "enableIcon": "Activer l'icône",
    "iconType": "Type d'icône",
    "iconPlacement": "Placement des icônes",
    "filled": "Rempli",
    "textOnly": "corps seulement",
    "border": "Bordure",
    "borderType": "Type de bordure",
    "cornerRadius": "Courbure d’angle",
    "width": "Largeur",
    "padding": "Marge interne",
    "top": "Haut",
    "bottom": "Bas",
    "left": "Gauche",
    "right": "Droite",
    "center": "Centrer",
    "default": "Par défaut",
    "formDefault": "Formulaire par défaut",
    "shadow": "Ombre",
    "color": "Couleur",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "blur": "Flou",
    "spread": "Diffuser",
    "fieldStyle": "Style de champ",
    "fontColor": "Couleur de la police",
    "inputTextFillColor": "Couleur de remplissage du texte de la saisie",
    "inputTextColor": "Couleur du texte de la saisie",
    "primaryColor": "Couleur principale",
    "primaryColorTooltip": "Contrôle la couleur pour l'état de survol et l'état dynamique.",
    "inputTextColorTooltip": "Contrôle la couleur du texte saisi dans les champs de feedback.",
    "mapPrimaryColorToButtonColor": "Associer la couleur principale à la couleur des boutons",
    "label": "Intitulé",
    "fontFamily": "Famille de polices",
    "size": "Taille",
    "weight": "Épaisseur",
    "fontWeightTooltip": "Applicable dans le cas de paragraphes",
    "fontWeightOptions": {
      "thin": "100 - Fin",
      "extraLight": "200 - Extra Light",
      "light": "300 - Léger",
      "normal": "400 - Normal",
      "medium": "500 - Moyen",
      "semiBold": "600 - Semi-gras",
      "bold": "700 - Gras"
    },
    "placeholder" : "Paramètre fictif",
    "customCSS" : "CSS personnalisé",
    "backgroundImage" : "Image d’arrière-plan",
    "headerImage" : "Image d’en-tête",
    "miscellaneous" : "Divers",
    "agencyBranding" : "Personnalisation de marque de l’agence",
    "imageUploadMessage" : "Cliquez ou faites glisser un fichier image dans cette zone pour le télécharger",
    "backgroundImageTooltipMessage" : "L’image d’arrière-plan est destinée à couvrir toute la page ; elle fournit une toile de fond visuellement attrayante pour le formulaire. Pour afficher l’image d’arrière-plan, cliquez sur l’option Aperçu.",
    "headerImageTooltipMessage" : "L’image d’en-tête est conçue pour couvrir toute la largeur du formulaire et reste positionnée en haut du formulaire. Pour afficher l’image d’en-tête, cliquez sur l’option Aperçu.",
    "onSubmit" : "Sur Envoyer",
    "facebookPixelID" : "ID du pixel Facebook",
    "facebookPixelIDMessage" : "Ignorez ce champ si vous prévoyez d’utiliser ce formulaire/ce sondage dans un entonnoir",
    "facebookPixelEvents" : "Événements du pixel Facebook",
    "onpageView" : "Sur la vue de la page",
    "stickyContact" : "Contact épinglé",
    "stickyContactMessage" : "Mémorise et remplit automatiquement les coordonnées lorsque vous revenez sur le même appareil et le même navigateur.",
    "fieldDescription" : "Description du champ",
    "fieldTitle" : "Titre du champ",
    "queryKey" : "Clé de la requête",
    "querykeyTooltipMessage" : "La clé de la requête qui peut être utilisée comme paramètre d’URL pour remplir ce champ.",
    "required" : "Obligatoire",
    "hidden" : "Masqué",
    "hiddenValue" : "Valeur masquée",
    "enableCountryPicker" : "Activer le sélecteur de pays",
    "altText" : "Texte de remplacement",
    "optionImageAlt" : "Option image",
    "bannerAlt" : "banner",
    "avatarAlt" : "Avatar Name",
    "alignment" : "Alignement",
    "imageWidth" : "Largeur de l’image",
    "imageHeight" : "Hauteur de l’image",
    "logic" : "Logique",
    "pleaseInput" : "Veuillez saisir",
    "editHTML" : "Modifier le HTML",
    "textStyle" : "Style du texte",
    "subText" : "Sous-titre",
    "text" : "Texte",
    "buttonStyle" : "Style du bouton",
    "fullWidth" : "Pleine largeur",
    "htmlMessage" : "Le HTML personnalisé va ici",
    "htmlEditorHeader" : "JAVASCRIPT/HTML PERSONNALISÉ",
    "htmlEditorBodyMessage" : "Ajoutez votre code ici",
    "scriptAdded" : "Script Added!",
    "sourceAdded" : "Source Added!",
    "yesSave" : "Oui, sauvegarder",
    "cancelKeep" : "Annuler, Garder",
    "done" : "Terminé",
    "addElement" : "Ajouter un élément",
    "addUrlLike" : "Veuillez inclure des URL valides, par exemple",
    "doNotAddRelativePath" : "N’ajoutez pas de chemins relatifs comme",
    "or" : "ou",
    "addCustomFields" : "Ajouter des champs personnalisés",
    "customFieldSearch" : "Rechercher par nom",
    "enterSourceValue" : "Saisissez la valeur source",
    "shortLabel" : "Courte description",
    "shortLabelPlaceholder" : "police une description courte",
    "labelPlaceholder" : "saisir un mot-clé",
    "fileUploadPlaceholder" : "télécharger un fichier",
    "imagePlaceholder" : "Image",
    "fillValuesPlaceholder" : "Remplissez les valeurs",
    "customCSSTooltip" : "Le CSS personnalisé a la priorité sur le style et les thèmes des formulaires et peut avoir un impact sur le style du thème.",
    "fontFamilyTooltip" : "Le générateur prend en charge tous les types de polices (même si vous ne les voyez pas dans la liste). Veuillez rechercher votre police dans le menu déroulant",
    "useGDPRCompliantFont" : "Utilisez une police conforme au RGPD",
    "enableTimezone" : "Activer le fuseau horaire",
    "inputStyle" : "Style de saisie",
    "conditionalLogicAlertOnSubmit" : "La logique conditionnelle aura ici la priorité sur le message/la redirection",
    "conditionalLogicAlertOnShowHide" : "La logique conditionnelle aura ici la priorité sur les paramètres cachés",
    "placeholderFacebookPixelIdInput" : "Entrez l’ID du pixel Facebook",
    "doNotShowMessage" : "Ne plus afficher",
    "creatingForm" : "votre champ...",
    "creatingSurvey" : "votre sondage…",
    "creatingQuiz" : "Créez votre quiz…",
    "errorCreatingForm" : "là a été une erreur lors de la création de votre formulaire. Veuillez réessayer.",
    "errorCreatingSurvey" : "Il y a eu une erreur dans votre sondage. Veuillez réessayer.",
    "errorCreatingQuiz" : "La création de votre quiz a été une erreur. Veuillez réessayer.",
    "redirectMessage" : "Vous serez redirigé vers :",
    "themes" : {
      "themes" : "Thèmes",
      "alertThemeMessage" : "Le changement de thème entraînera la perte de toutes les modifications de style actuelles.",
      "useTheme" : "Utiliser le thème",
      "removeTheme" : "Supprimer le thème"
    },
    "box" : "Cadre",
    "line" : "Ligne",
    "message" : "Message",
    "openUrl" : "URL de redirection",
    "borderTypeList" : {
      "dotted" : "En pointillés",
      "dashed" : "En traits discontinus",
      "solid" : "Uni",
      "none" : "Aucun"
    },
    "button" : "Bouton",
    "emailNotification" : "Notification par e-mail",
    "emailNotificationSubheader" : "Recevez un e-mail lorsque quelqu’un remplit votre formulaire",
    "subject" : "Objet",
    "emailTo" : "E-mail (À)",
    "senderName" : "Nom de l’expéditeur",
    "senderNameWarning" : "Votre (nom de sous-compte) sera ajouté si le champ est laissé vide",
    "emailError" : "Au moins une adresse e-mail est requise",
    "emailTooltip" : "La première adresse e-mail est désignée pour le champ « À ». Toutes les adresses e-mail ultérieures seront incluses dans le champ « Cc ».",
    "clear" : "Effacer",
    "filter" : "Filtrer",
    "noResults" : "Aucun résultat",
    "search" : "Rechercher",
    "showNotificationsSettings" : "Afficher les paramètres de notification",
    "emailServicePaid" : "Cette fonctionnalité est un service payant et entraînera des frais en fonction de votre utilisation.",
    "integration" : "Intégration",
    "validation" : {
      "fieldRequired" : "Le champ est obligatoire",
      "maxLengthExceeded" : "Durée maximale dépassée ({max} )"
    },
    "securityValidation": {
      "title":"Security issues detected. The following are not allowed:",
      "cookieAccess": "Cookie access detected (document.cookie). This is not allowed for security reasons.",
      "storageAccess": "localStorage.getItem() - reading from localStorage is not allowed.",
      "evalUsage": "Use of eval() is not allowed as it can execute arbitrary code.",
      "dynamicFunction": "Dynamic function creation (new Function) is not allowed for security reasons.",
      "stringExecution": "Passing strings to setTimeout/setInterval is not allowed as it can execute arbitrary code. Use function references instead."
    },
    "products": {
      "subscriptionBadge": "Abonnement",
      "trialBadge": "Essai gratuit de {days} jours",
      "setupFee": "Frais de configuration uniques",
      "quantity": "Quantité",
      "productImageAlt": "Image du produit",
      "bumpIconAlt": "Icône de l'option complémentaire"
    },
    "payment" : {
      "payments" : "Paiements",
      "connected" : "Connecté",
      "connect" : "Se connecter",
      "liveModeOn" : "Mode en direct",
      "status" : "Statut",
      "test" : "Test",
      "live" : "En direct",
      "paymentFields" : "Champs de paiement",
      "suggestAnAmount" : "Suggérer un montant",
      "recurringPayments" : "Paiements récurrents",
      "selectCurrency" : "Sélectionnez la devise",
      "tagActiveBGColor" : "Couleur de la balise active",
      "includeOtherAmount" : "Inclure un autre montant",
      "footerInfo" : "Informations sur le pied de page",
      "paymentType" : "Type de paiement",
      "sellProducts" : "Vendre des produits",
      "customAmount" : "Montant personnalisé",
      "collectPayment" : "Collecter le paiement",
      "generalSettings" : "Champs généraux",
      "securePayments" : "*100 % verrouiller et protéger les paiements*",
      "error" : {
        "addMainProductFirst" : "Créez un produit PRINCIPAL",
        "priceNotFoundForBumpProduct" : "prix trouvé pour le produit incitatif",
        "productAlreadyAdded" : "produit déjà ajouté"
      },
      "product" : {
        "addProduct" : "Ajouter un produit",
        "productSettings" : "Paramètres du produit",
        "bumpTag" : "Option complémentaire",
        "settingsAria" : "Paramètres du produit",
        "deleteAria" : "Supprimer le produit",
        "selectProduct" : "Sélectionnez un produit",
        "editThisProduct" : "Pour modifier ce produit",
        "clickHere" : "Cliquez ici",
        "show" : "Afficher",
        "description" : "Description",
        "image" : "Image",
        "layoutSettings" : "Paramètres de mise en page",
        "singleColumn" : "Colonne unique",
        "twoColumn" : "Deux colonnes",
        "threeColumn" : "Trois colonnes",
        "maxProductError" : "Un maximum de 20 produits est autorisé dans un formulaire",
        "productSelectPlaceholder" : "Veuillez sélectionner un produit",
        "orderConfirmation" : "Confirmation de commande",
        "orderConfirmationWarning" : "La page de confirmation de commande s'affichera une fois le paiement effectué",
        "quantity" : "Quantité",
        "createProduct" : "Pour créer un produit",
        "noProductsAdded" : "Aucun produit ajouté pour l'instant",
        "productsWillShowHere" : "Une fois que vous inclure des produits, ils s'afficheront ici",
        "chooseProductType" : "produit",
        "mainProduct" : "Produit PRINCIPAL"
      },
      "bumProduct" : {
        "price" : "prix",
        "variant" : "variante",
        "headline" : "titre",
        "otoHeadline" : "titre' ota",
        "otoText" : "corps du total",
        "enableImage" : "activer image",
        "imageMessage" : "Nous avons saisi l' imagede produit par défaut",
        "orUploadADifferentImage" : "ou télécharger une autre image",
        "bumpProducts" : "produits incitatifs",
        "bumpProduct" : "produit incitatif",
        "enableBump" : "activer le bump",
        "orderBumpStyle" : "style du order bump",
        "classic" : "Classic",
        "modern" : "récent",
        "icon" : "icône",
        "bumpTemplate" : "Sélectionner un Modèle",
        "highlightText" : "mettre dans le corps",
        "showPrice" : "afficher le prix",
        "bumpPriceColor" : "prix incitatif",
        "bumpIconColor" : "icône incitatif",
        "bumpBackgroundColor" : "arrière-plan incitatif",
        "highlightTextColor" : "mettre dans le corps",
        "headlineColor" : "titre",
        "otoHeadlineColor" : "titre' ota",
        "otoTextColor" : "corps du total",
        "bumpBorderColor" : "bordure",
        "priceRequired" : "Le prix est obligatoire",
        "headlineRequired" : "Le titre est obligatoire",
        "otoHeadlineRequired" : "Le titre OTO est obligatoire",
        "otoTextRequired" : "Le texte OTO est obligatoire",
        "bumpProductTooltip" : "Un petit module disponible lors du paiement pour multiplier la valeur de l'essai. clients peuvent le comprendre avec une personne.",
        "templateOne" : "Modèle 1",
        "templateTwo" : "Modèle 2",
        "templateThree" : "Modèle 3",
        "animationIcon" : {
          "none" : "Aucun",
          "arrow" : "flèche",
          "fire" : "Déclenche",
          "plus" : "plus",
          "giftBox" : "cadre",
          "timer" : "compte à rebours",
          "cracker" : "cookies",
          "snack" : "en-tête",
          "partyBalloon" : "e-mail de partie",
          "flash" : "instantané",
          "money" : "devise",
          "spaceShuttle" : "navigation dans espace"
        }
      },
      "coupons" : {
        "coupons" : "Coupons",
        "enableCoupon" : "Activer le coupon",
        "couponAlignment" : "Alignement des coupons",
        "left" : "Gauche",
        "right" : "Droite",
        "fullWidth" : "Pleine largeur",
        "tooltipMessage" : "Définissez la position de saisie du coupon parmi les types ci-dessous"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Utiliser la saisie semi-automatique pour l’adresse",
      "addressfields" : "Champs de l’adresse",
      "placeholderSearch" : "Rechercher une adresse",
      "autoCompleteTooltip" : "Permet de rechercher et de remplir automatiquement l’adresse.",
      "streetAddress" : "adresse postale",
      "autoCompleteAddressTitle" : "adresse e-mail",
      "newBadge" : "Nouveau",
      "defaultLabel" : "adresse",
      "searchPlaceholder" : "adresse",
      "mandataorySearch" : {
        "title" : "obligatoire in la barre de recherche",
        "primaryText" : "Utiliser la saisie semi-automatique pour adresse postale",
        "secondaryText" : "Quand un utilisateur a des interactions avec le champ d'adresse, ensuite, il a une adresse valide pour interagir.",
        "secondaryText1" : "in la barre de recherche sans sélectionner une adresse e-mail."
      }
    },
    "autoResponder" : "Répondeur automatique",
    "autoResponderSubheader" : "Envoi d’un e-mail automatisé à la personne qui soumet le formulaire (l’e-mail contient une copie des informations qu’elle a saisies dans le formulaire)",
    "replyToEmail" : "E-mail de réponse",
    "open" : "Ouverte",
    "won" : "Remportée",
    "lost" : "Perdue",
    "abandon" : "Abandonner",
    "selectAPipeline" : "Sélectionnez un pipeline",
    "stage" : "Étape",
    "status" : "Statut",
    "opportunityValue" : "Valeur de l’opportunité",
    "createNewPipeline" : "Créer un nouveau pipeline",
    "editOpportunitySettings" : "Modifiez les paramètres des opportunités",
    "contact" : "Contact",
    "opportunity" : "Opportunité",
    "business" : "Entreprise",
    "add" : "Ajouter",
    "more" : "Plus",
    "opportunityHeading" : "Où souhaitez-vous que votre opportunité soit mise à jour ?",
    "date" : {
      "dateSettings" : "Paramètres de date",
      "dateFormat" : "Format de date",
      "dateSeparator" : "Séparateur de date",
      "dateFormatTooltipMessage" : "Sélectionnez un format de date. J pour jour, M pour mois et A pour année",
      "dateSeparatorTooltipMessage" : "Sélectionnez un séparateur qui séparera le jour, le mois et l’année dans le format sélectionné dans Format de date",
      "disablePicker" : "Désactiver le sélecteur"
    },
    "restoreVersion" : "Restaurer la version",
    "versionHistory" : "Historique des versions",
    "errorMessage" : "Une erreur s’est produite, veuillez réessayer.",
    "version" : "Version :",
    "currentVersion" : "Version actuelle",
    "messageStyling" : "Style des messages",
    "validateEmailHeader" : "Valider l’e-mail",
    "validateEmailDescription" : "Le bouton deviendra visible une fois que l’utilisateur aura saisi son adresse e-mail. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "verifyEmail" : "Vérifier l'adresse e-mail",
    "validatePhoneHeader" : "Valider le numéro de téléphone",
    "validatePhoneDescription" : "Le bouton deviendra visible une fois que l’utilisateur aura saisi son numéro de téléphone. Cette fonctionnalité est conçue pour vous aider à générer des prospects de qualité.",
    "verifyPhone" : "Vérifiez le téléphone",
    "validatePhoneWarning" : "Pour activer la vérification OTP par SMS, assurez-vous que votre numéro de téléphone est configuré dans vos paramètres d’emplacement.",
    "addAnotherTnc" : "Ajoutez une autre CGU",
    "tnc1" : "T & C 1",
    "tnc2" : "CGU 2",
    "deleteCaps" : "SUPPRIMER",
    "deleteConfirmation" : "Saisissez SUPPRIMER pour confirmer",
    "marginPadding" : "Marge et remplissage",
    "style" : {
      "formLayoutType" : "Type de formulaire",
      "layoutType" : "Type de mise en page",
      "surveyType" : "Type de sondage",
      "oneColumn" : "Une colonne",
      "twoColumn" : "Deux colonnes",
      "singleLine" : "Ligne unique",
      "fieldWidth" : "Largeur du champ",
      "labelAlignment" : {
        "labelAlignment" : "Alignement des étiquettes",
        "labelWidth" : "Largeur de l’étiquette"
      },
      "fieldSpacing" : "Espacement des champs",
      "imageFieldSpacing" : "Espacement des images et des champs",
      "imageCornerRadius" : "Rayon des coins de l'image",
      "color" : "couleur",
      "fontColor" : "Couleur de police",
      "inputBackgroundColor" : "Couleur d'arrière-plan de la saisie",
      "inputBorder" : "Bordure de la saisie",
      "layout" : "Disposition",
      "colorsAndBackground" : "Couleurs et arrière-plan",
      "imageLayout" : {
        "imageLayout" : "Alignement du contenu de l'image",
        "showImage" : "Afficher l'image",
        "image" : "Image",
        "desktop" : {
          "topFixed" : "Épinglé en haut",
          "leftCenter" : "Centre gauche",
          "rightCenter" : "Centrer droite",
          "leftFixed" : "fixe gauche",
          "rightFixed" : "Fixé à droite",
          "background" : "Arrière-plan"
        },
        "mobile" : {
          "header" : "En-tête",
          "background" : "Arrière-plan"
        }
      },
      "focusPoint" : {
        "title" : "Point focal",
        "reset" : "Réinitialiser",
        "noImage" : "Aucune image n'a été téléchargée"
      },
      "advanceSettings" : "paramètres avancés",
      "inputField" : "Champ de saisie",
      "borderWidth" : "Épaisseur de la bordure",
      "borderColor" : "Couleur de la bordure",
      "borderStyle" : "Style de bordure",
      "fontSize" : "Taille de la police",
      "fontWeight" : "Graisse de la police",
      "labelColor" : "Couleur de l’étiquette",
      "placeholderColor" : "Couleur du paramètre fictif",
      "shortLabelColor" : "Couleur de l’étiquette courte"
    },
    "replyToTooltip" : "Personnalisez l’adresse e-mail de réponse par défaut en utilisant {'{'}{'{'}contact.email{'}'}{'}'} pour permettre de répondre au contact qui envoie le formulaire.",
    "content" : "Contenu",
    "calculations" : "Calculs",
    "uploadOptions" : "Options de chargement",
    "opportunitySettingsWarning" : "Veuillez configurer les paramètres de l’opportunité en cliquant sur le bouton Modifier les paramètres de l’opportunité.",
    "startValue" : "Valeur de démarrer",
    "endValue" : "Valeur finale",
    "today" : "Aujourd'hui",
    "thisWeek" : "Cette semaine",
    "last7Days" : "7 derniers jours",
    "thisMonth" : "Ce mois-ci",
    "last30Days" : "Dernier mois",
    "question" : "Question",
    "createContactOnPartialSubmission" : "Créer un contact lors d’un envoi partiel",
    "howItWorks" : "Comment cela fonctionne-t-il ?",
    "createContactOnPartialSubmissionDescription" : "Terminez la diapositive et cliquez sur « Suivant ». Un nouveau contact sera automatiquement créé et stocké.",
    "swapWarningMessageSurvey" : "La modification ou l’échange d’options aura un impact sur ce champ personnalisé à tous les endroits où il est utilisé. Il peut également réinitialiser la logique conditionnelle. ",
    "swapWarningMessageForm" : "La modification ou l’échange d’options aura un impact sur ce champ personnalisé à tous les endroits où il est utilisé. ",
    "migrationWarningMessage" : "Cette fonctionnalité a été migrée vers la logique conditionnelle du sondage.",
    "optionLabel" : "Intitulé de l’option",
    "calculationValue" : "Valeur de calcul",
    "addOption" : "Ajouter une option",
    "enableCalculations" : "Activer les calculs",
    "allowOtherOption" : "Autoriser une autre option",
    "productSelectionSubtext" : "Le personnel n'a pas reçu de texte à traduire.",
    "multi" : "Plusieurs",
    "single" : "personne",
    "productSelectionHeading" : "Sélection de produit",
    "spreadToColumns" : "diffuser vers les colonnes",
    "columns" : "Colonnes",
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "title" : "Intégrer le formulaire",
      "embedCode" : "Code d'intégration",
      "useInFunnelOrEmbedCode" : "Utiliser dans un entonnoir / code d'intégration",
      "iframeEmbed" : "intégrer Iframe",
      "layout" : {
        "title" : "Type de disposition d'intégration",
        "description" : "Sélectionnez une disposition à intégrer dans un entonnoir ou un site web externe",
        "allowMinimize" : "Autoriser à réduire",
        "minimizedTitlePlaceholder" : "Titre réduit",
        "leftAlignAlt" : "Aligner à gauche",
        "rightAlignAlt" : "Aligner à droite"
      },
      "triggerType" : "Type de déclenchement",
      "triggers" : {
        "seconds" : "secondes"
      },
      "activation" : {
        "title" : "Options d'activation",
        "visit" : "accès"
      },
      "deactivation" : {
        "title" : "Options de désactivation",
        "times" : "fois"
      },
      "copyEmbedCode" : "Copier le code d'intégration",
      "copyFormLink" : "Copier le lien du formulaire",
      "openFormLink" : "Ouvrir le lien du formulaire",
      "invalidInput" : "Entrée invalide !",
      "funnel" : {
        "funnel" : "entonnoir",
        "chooseStep" : "Erreur",
        "copyCodeAndOpenFunnel" : "copier le code et ouvrir entonnoir"
      },
      "share" : {
        "share" : "Partager",
        "shareViaSocials" : "partager via les réseaux sociaux",
        "copyLink" : "copier le lien"
      },
      "email" : {
        "email" : "des E-mail",
        "shareViaEmail" : "partager via E-mail",
        "emailButton" : "des E-mail",
        "blankTemplate" : "Modèle vide",
        "emailMarketingTemplates" : "Modèles de marketing par E-mail",
        "or" : "ou",
        "chooseTemplate" : "Choisissez parmi vos modèles",
        "continue" : "continuer"
      }
    },
    "rating" : {
      "icon" : "icône",
      "iconAlignment" : "alignement des icône",
      "count" : "nombre",
      "lowestRating" : "évaluation minimale",
      "highestRating" : "évaluation maximale",
      "iconSelectedState" : "État de icône sélectionné",
      "iconUnselectedState" : "État de icône non sélectionné",
      "rating" : "évaluation",
      "ratingSettings" : "paramètres évaluation",
      "calculationType" : {
        "calculationType" : "Comment archiver les champs évaluation in les champs personnalisés",
        "calculationTypeTooltip" : "Quand vous prévoyez de fournir le texte que vous souhaitez traduire.",
        "absolute" : "total",
        "percentage" : "Pourcentage",
        "fraction" : "diviser"
      }
    },
    "desktopMode" : "mode Ordinateur",
    "mobileMode" : "mode Mobile",
    "versions" : "variantes",
    "advanced" : "Avancé",
    "edit" : "Modifier",
    "settings" : "Paramètres",
    "submissions" : "Envois",
    "undo" : "Annuler",
    "redo" : "Restaurer",
    "customValues" : "Valeurs personnalisées",
    "pickBgFromImage" : "Ajoute un flou à l'arrière-plan de votre boîte de message. Si vous choisissez une couleur de fond pour la boîte de message, elle apparaîtra par-dessus la boîte de message floutée.",
    "pickBgFromImageTip" : "Choisit une couleur à fort comparer pour l'image de fond. Message : ne sera pas appliqué si l'arrière-plan du Formulaire ne contient pas d'image",
    "messageBackgroundBlur" : "Flou d'arrière-plan",
    "confirmationMessage" : "Message de confirmation",
    "deleteOption" : "Supprimer l'option",
    "deleteConfirmationModal" : {
      "defaultDescription" : "suppression d'une option aura un impact sur ce champ personnalisé à tous places où il est utilisé. Voulez-vous vraiment le supprimer ?",
      "validationMessage" : "Veuillez saisir le texte que vous souhaitez faire traduire.",
      "validationError" : "Veuillez saisir"
    },
    "disqualifyImmediately" : "Disqualifier immédiatement",
    "disqualifyAfterSubmit" : "Disqualifier après envoi",
    "generalSettings" : "paramètres général",
    "advancedSettings" : "paramètres avancés",
    "customFieldName" : "nom de secteur",
    "customFieldNameTooltip" : "Ce nom de secteur est unique par secteur.",
    "uniqueKey" : "clé unique",
    "uniqueKeyTooltip" : "Ce clé est unique par secteur.",
    "selectContactAssociation" : "Sélectionnez l'association avec les Contacts",
    "associations" : "Liens",
    "createNewAssociation" : "Créer un nouveau lien",
    "selectAnAssociation" : "Veuillez sélectionner une association",
    "loadingAssociations" : "Chargement des associations...",
    "unknownAssociation" : "Lien anonyme",
    "manyToMany" : "Plusieurs à plusieurs",
    "failedToLoadAssociations" : "Échec du chargement des associations",
    "noAssociationsFound" : "Aucun lien trouvé",
    "keepThisField" : "Conservez ce secteur",
    "association" : "Association",
    "customObject" : "Objet personnalisé",
    "customObjects" : "Objets personnalisés",
    "object" : "Objet",
    "editAssociation" : "Modifier le lien {objectName}",
    "editAssociationButton" : "{edit} {objectName} {association}",
    "fields" : "Champs",
    "primaryFieldWarning" : "{fieldName} est un secteur PRINCIPAL pour {objectSingular} et est obligatoire pour créer ou actualiser un {objectSingular}.",
    "primaryFieldTitle" : "{fieldName} est obligatoire pour créer ou actualiser le document {objectSingular}.",
    "removeAllFields" : "Effacer tous les champs {objectSingular}",
    "customObjectsFallback" : "Objets personnalisés",
    "noneAssociation" : "Aucun",
    "noneAssociationDescription" : "Aucun lien avec les Contacts (aucun champ Contact n’est présent)",
    "survey" : {
      "layoutType" : "Type de sondage",
      "oneQuestionPerPage" : "Une question à la fois",
      "allQuestionsOnePage" : "Plusieurs à la fois"
    },
    "quizQuestions" : "quiz",
    "choiceElements" : "composants au choix",
    "otherElements" : "d'autres composants",
    "listEditor" : {
      "prefillValueHeader" : "valeur de préremplir",
      "labelPlaceholder" : "intitulé",
      "valuePlaceholder" : "valeur",
      "optionRequiredError" : "Le champ de l’option est obligatoire"
    },
    "field" : "champ",
    "scoreEditor" : {
      "addFieldPlaceholder" : "ajouter un champ",
      "fieldLabel" : "champ",
      "numberLabel" : "nombre"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Types de fichier",
      "all" : "chaque",
      "pdf" : "PDF",
      "docxDoc" : "FACTURE",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPG",
      "xlsCsv" : "xls/CSV"
    },
    "ok": "OK",
    "allowMultipleFiles": "Activez plusieurs fichiers",
    "maxFileLimit": "Limite maximum des fichier",
    "privacyPolicy": "Politique de confidentialité",
    "termsOfService": "Conditions de service",
    "billingFrequency": "Fréquence de facturation",
    "otherAmount": "Autre montant",
    "exampleUrlPlaceholder": "https://www.exemple.com",
    "checkboxStyles": {
      "standardAlt": "Style standard de la case à cocher",
      "bubbleAlt": "Style de case à cocher bulle"
    },
    "previewIcons" : {
      "exportAlt" : "Icône d'exportation",
      "shipmentAlt" : "Icône d'expédition",
      "resultAlt" : "Icône de la page de résultats"
    },
    "examples" : {
      "sampleUrl" : "https://exemple.com"
    },
    "showing": "Affichage",
    "of": "de",
    "enterCouponCode": "Saisir le code de réduction",
    "apply": "Appliquer",
    "paymentWillBeProcessed": "Le paiement sera traité dès que vous procéderez à l'étape suivante",
    "paymentWillBeProcessedNextSlide": "Le paiement sera traité dès que l'utilisateur passera à la diapositive suivante",
    "showThisAlertToUsers": "Montrer cette alerte aux utilisateurs",
    "sixteenDigitCardNumber": "Carte à 16 chiffres",
    "mmYy": "MM / AA",
    "cvc": "CVC",
    "pleaseFillRequiredFields": "Veuillez remplir tous les champs obligatoires !",
    "opportunitySettingsIncomplete": "Paramètres des opportunités incomplets",
    "opportunitySettingsIncompleteDescription": "Ce formulaire inclut des champs d'opportunité, mais les paramètres des opportunités n'ont pas été mis à jour. Veuillez configurer ces paramètres pour enregistrer le formulaire.",
    "ariaAttributes": {
      "iconSearch": "Recherche d'icônes"
    },
    "alt": {
      "standardRadioStyle": "Style radio standard",
      "bubbleRadioStyle": "Style radio bulle"
    },
    "value": "Valeur",
    "jumpTo": "Aller à",
    "thankYouJohnDoe": "Merci, Monsieur John Doe",
    "total": "Total",
    "urlExamples": {
      "simple": "exemple.com",
      "https": "https://exemple.com",
      "withPath": "exemple.com/path",
      "fullPath": "https://www.example.com/path"
    }
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "choix du personnel",
      "multipleChoice" : "Choisissez plusieurs",
      "yesNo" : "oui /Non",
      "shortAnswer" : "short avec réponse",
      "longAnswer" : "Une réponse plus longue que",
      "number" : "nombre",
      "singleDropdown" : "personne",
      "multiDropdown" : "liste liste déroulante"
    },
    "personal" : {
      "fullName" : "Nom complet",
      "firstName" : "prénom",
      "lastName" : "nom",
      "dateOfBirth" : "Date de naissance",
      "phone" : "Téléphone",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "bouton"
    },
    "integration" : {
      "sellProducts" : "Vendre des produits",
      "collectPayment" : "collecter le paiement"
    },
    "address" : {
      "address" : "adresse",
      "streetAddress" : "adresse postale",
      "city" : "ville",
      "state" : "État",
      "country" : "pays",
      "postalCode" : "code postal",
      "organization" : "groupe",
      "website" : "site web",
      "websitePlaceholder" : "L'URL du web va ici"
    },
    "text": {
      "singleLine": "Ligne unique",
      "multiLine": "Plusieurs ligne",
      "textBoxList": "Liste des zones de texte"
    },
    "choiceElements" : {
      "singleDropdown" : "personne",
      "multiDropdown" : "liste liste déroulante",
      "checkbox" : "case à cocher",
      "radio" : "radio"
    },
    "customized" : {
      "text" : "Cliquez pour modifier ce texte",
      "html" : "HTML",
      "htmlPlaceholder" : "Le HTML Personnalisée va ici",
      "captcha" : "captcha",
      "source" : "Source",
      "termsAndConditions" : "T et C",
      "termsAndConditionsPlaceholder" : "J'accepte les termes et conditions reçus via l'entreprise. via la soumission de mon numéro de téléphone, j'accepte de transmettre des messages de texte à l'entreprise.",
      "score" : "score"
    },
    "other" : {
      "image" : "image",
      "fileUpload" : "télécharger le fichier",
      "monetary" : "monétaire",
      "number" : "nombre",
      "datePicker" : "sélecteur de Date",
      "signature" : "signature"
    },
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey": {
    "typeOfBuilder": "Sondage",
    "survyeStyle": "Style du sondage",
    "surveyName": "Nom du sondage",
    "surveyElement": "Élément du sondage",
    "addSurveyElement": "Ajouter un élément de sondage",
    "cloneSlide": "Cloner la diapositive",
    "unsavedAlertMessage": "Le sondage comporte des éléments non enregistrés. Voulez-vous vraiment quitter et supprimer tous les éléments non enregistrés ?",
    "thirdPartyScriptAlertMessage": "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités intéressantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Nous vous recommandons donc de vérifier le contenu de ce script avant de l’enregistrer dans le sondage.",
    "integrateHeader": "Intégrer le sondage",
    "integrateSubHeader": "Utilisez les options suivantes pour intégrer votre sondage personnalisé à votre site web",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-le facilement où vous le souhaitez.",
    "onSurveySubmission": "À propos de l’envoi des sondages",
    "surveySettings": "Paramètres du sondage",
    "oneQuestionAtTime": "Une question à la fois",
    "backButton": "Bouton Retour",
    "backButtonTooltipMessage": "Le bouton Retour permet aux utilisateurs de revenir à la diapositive précédente",
    "disableAutoNavigation": "Désactiver la navigation automatique",
    "disableAutoNavigationTooltipMessage": "Accédez automatiquement aux réponses de l'utilisateur.",
    "autoNavigation": "navigation automatique",
    "autoNavigationTooltipMessage": "Accédez automatiquement aux réponses de l'utilisateur.",
    "progressBar": "Barre de progression",
    "progressBarTooltipMessage": "La désactivation de cette option supprimera la barre de progression de l'enquête",
    "disableAnimation": "Désactiver l’animation",
    "disableAnimationTooltipMessage": "L’activation de cette option désactivera l’animation de transition des diapositives",
    "scrollToTop": "Faire défiler vers le haut",
    "scrollToTopTooltipMessage": "Si cette option est activée, le sondage défilera vers le haut sur la diapositive suivante",
    "submitSurvey": "Soumettre le sondage",
    "disqualifyImmediately": "Disqualifier immédiatement",
    "disqualifyAfterSubmit": "Disqualifier après envoi",
    "disqualifyAfterSubmitLowerCase": "Disqualifier après envoi",
    "footerHTML": "Pied de page HTML",
    "footerHTMLMessage": "Vous pouvez écrire du CSS personnalisé (à l’aide d’une balise de style) et du HTML dans le même cadre",
    "editFooter": "Modifier le pied de page",
    "disqualifySettings": "Disqualifier les paramètres",
    "disqualifyImmediatelyLabel": "Immédiatement",
    "disqualifyAfterSubmitLabel": "Après soumission",
    "slideConflictAlertMessage": "Cette diapositive contient plusieurs questions qui ont une logique définie. Cela peut provoquer un comportement inattendu",
    "addSlide": "Ajouter une diapositive",
    "settings": "Paramètres",
    "delete": "Supprimer",
    "slideDeleteAlertMessage": "Voulez-vous vraiment supprimer cette diapositive ?",
    "slideDeleteBetweenAlertMessage": "Cela aura pour effet de réorganiser les autres diapositives. Voulez-vous vraiment supprimer cette diapositive ?",
    "slideLabel": "Diapositive {n}",
    "slideName": "Nom de la diapositive",
    "slidePosition": "Position de la diapositive",
    "jumpTo": "Aller à",
    "jumpToSubText": "Accédez à une diapositive spécifique",
    "enableTimezoneSurvey": "L’activation de cette option permettra de saisir les informations de fuseau horaire de la personne qui envoie le sondage",
    "footer": {
      "footer": "Pied de page",
      "enableNewFooter": "Activer le nouveau pied de page",
      "stickToSurvey": " Attacher au sondage",
      "backgroundFill": "Remplissage de l’arrière-plan",
      "footerHeight": "Hauteur du pied de page",
      "enableProgressBar": "Activer la barre de progression",
      "buttons": "Boutons",
      "button": "bouton",
      "buttonType": "Type de bouton",
      "fillNext": "Remplir (suivant)",
      "fillPrevious": "Remplir (précédent)",
      "fillSubmit": "Remplir (Envoyer)",
      "textColor": "Texte du bouton",
      "position": "Position",
      "previousText": "Précédent (texte)",
      "nextText": "Suivant (texte)",
      "submitText": "Envoyer (texte)",
      "fillComplete": "Remplissage terminé",
      "fillInactive": "Remplissage inactif",
      "footerType": "Type de pied de page",
      "stickToCard": "Attacher à la carte",
      "stickToPage": "Attacher à la page",
      "stepTextColor": "couleur de corps",
      "progressBarFill": "remplir de barre de progression",
      "progressBarInactive": "barre de progression inactif",
      "arrowFill": "remplir de la flèche",
      "submitColorMobile": "envoyer (couleur)",
      "arrowFillColor": "couleur de remplir de la flèche",
      "buttonTypes": {
        "textAndArrow": "Texte et flèche",
        "onlyText": "Texte uniquement",
        "onlyArrow": "Flèche uniquement"
      },
      "positions" : {
        "leftAndRight" : "Gauche et droite"
      },
      "placeholders" : {
        "prev" : "Précédent",
        "next" : "Suivant",
        "submit" : "Envoyer"
      }
    },
    "surveyNotfication" : "Notification du sondage",
    "style" : {
      "surveyPadding" : "Marge interne du sondage"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Intégrer ou partager le sondage",
      "share" : {
        "openFormLink" : "ouvrir le lien du sondage"
      },
      "email" : {
        "emailSubheader" : "Créez un e-mail vide et remplissez votre sondage, sortant d'un modèle et remplissez-le de manière appropriée."
      }
    },
    "autoResponderSubheader": "Envoi d’un e-mail automatisé à la personne qui soumet le sondage (l’e-mail contient une copie des informations qu’elle a saisies dans le sondage)",
    "sendSubmissionsAsPdf": "Transmettre l'envoi de sondage au format PDF",
    "switchToOneQuestionAtTimeOn": "L’activation de « Une question à une Date",
    "switchToOneQuestionAtTimeOff": "La configuration de votre logique Date",
    "switchToOneQuestionAtTimeOnWarning": "Certains conditions ne seront plus exécutées comme Date",
    "switchToOneQuestionAtTimeOffWarning": " Certains conditions conçue pour le flux de travail personnel cesseront de fonctionner comme prévus.",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive, même s'il ne termine pas l'enquête.",
    "dragDrop": {
      "imageLabel": "Image {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Sondage {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Politique de confidentialité</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Conditions d'utilisation</a></p>",
      "smsConsent": "J'accepte de recevoir des notifications SMS, des alertes et des communications marketing occasionnelles de la part de l'entreprise. La fréquence des messages varie. Des frais de message et de données peuvent s'appliquer. Envoyez HELP par SMS au (XXX) XXX-XXXX pour obtenir de l'aide. Vous pouvez répondre STOP pour vous désabonner à tout moment."
    }
  },
  "form" : {
    "typeOfBuilder" : "Formulaire",
    "formStyle" : "Style du formulaire",
    "formElement" : "Élément de formulaire",
    "addFormElement" : "Ajouter un élément de formulaire",
    "addConditionalLogic" : "Ajouter une logique conditionnelle",
    "openConditionalLogic" : "Ouvrir la logique conditionnelle",
    "inlineForm" : "Formulaire intégré",
    "formName" : "Nom du formulaire",
    "fullScreenMode" : "Mode plein écran",
    "fullScreenModetooltip" : "En l’activant, le formulaire s’étendra sur toute la largeur de son conteneur, jusqu’au bord de la zone d’intégration tout en respectant la largeur du formulaire.",
    "enableTimezoneForm" : "L’activation de cette option permettra de saisir les informations sur le fuseau horaire de la personne qui envoie le formulaire",
    "formSettings" : "Paramètres du formulaire",
    "unsavedAlertMessage" : "Le formulaire contient des éléments non enregistrés. Voulez-vous vraiment quitter et supprimer tous les éléments non enregistrés ?",
    "thirdPartyScriptAlertMessage" : "Les scripts tiers placés dans le bloc HTML peuvent offrir des fonctionnalités intéressantes, mais ils présentent également des risques pour la confidentialité, la sécurité, les performances et le comportement de la page. Nous vous recommandons donc de vérifier le contenu de ce script avant de l’enregistrer dans le formulaire.",
    "onFormSubmission" : "Envoi sur formulaire",
    "integrateForm" : "Intégrer le formulaire",
    "embedlayoutType" : "saisir de mise en page’ intégrer",
    "embedlayoutTypeSubMessage" : "Sélectionnez une disposition à intégrer dans un entonnoir ou un site web externe",
    "triggerType" : "Type de déclenchement",
    "showOnScrolling" : "Afficher lors du défilement",
    "showAfter" : "Afficher après",
    "seconds" : "secondes",
    "alwaysShow" : "Toujours afficher",
    "activationOptions" : "Options d’activation",
    "activateOn" : "Activer le",
    "visit" : "visiter",
    "alwaysActivated" : "Toujours activé",
    "deactivationOptions" : "Options de désactivation",
    "deactivateAfterShowing" : "Désactiver après affichage",
    "times" : "fois",
    "deactiveOnceLeadCollected" : "Désactiver une fois le prospect collecté",
    "neverDeactivate" : "Ne jamais désactiver",
    "copyEmbedCode" : "Copier le code d’intégration",
    "copyFormLink" : "Copier le lien du formulaire",
    "openFormLink" : "Ouvrir le lien du formulaire",
    "inline" : "Intégré",
    "inlineDescription" : "Un formulaire intégré apparaît avec le contenu de la page en tant qu’élément natif. Il ne se superpose pas et ne peut pas être fermé ou réduit.",
    "inlineHoverDescription" : "Un formulaire intégré apparaît avec le contenu de la page en tant qu’élément natif. Il ne se superpose pas et ne peut pas être fermé ou réduit.",
    "popup" : "Fenêtre pop-up",
    "popupDescription" : "Une fenêtre pop-up affiche le formulaire sous la forme d’une superposition à l’intérieur d’une boîte à lumière. Elle ne peut pas être réduite, mais elle peut être fermée.",
    "popupHoverDescription" : "Une fenêtre pop-up affiche le formulaire sous la forme d’une superposition à l’intérieur d’une boîte à lumière. Elle ne peut pas être réduite, mais elle peut être fermée.",
    "politeSlideIn" : "Slide-in non invasif",
    "politeSlideInDescription" : "Un slide-in non invasif apparaît en bas de l’écran et disparaît une fois fermé",
    "politeSlideInHoverDescription" : "Apparaît en bas de l’écran et disparaît une fois fermé",
    "stickySidebar" : "Barre latérale épinglée",
    "stickySidebarDescription" : "Une barre latérale épinglée apparaîtra sur le côté de l’écran et peut être réduite à un onglet qui s’attache sur le côté de la fenêtre",
    "stickySidebarHoverDescription" : "apparaîtra sur le côté de l’écran et peut être réduite à un onglet qui s’attache sur le côté de la fenêtre",
    "allowMinimize" : "Autoriser à réduire",
    "conditonalLogic" : {
      "conditions" : "Conditions",
      "noExistingCondition" : "Il n’y a encore aucune condition existante",
      "freeRoamMessage" : "Vous êtes libre de vous déplacer sans vous soucier des règles, du moins pour l’instant",
      "addNewCondition" : "Ajouter une nouvelle condition",
      "redirectToUrl" : "URL de redirection",
      "displayCustomMessage" : "Afficher un message personnalisé",
      "disqualifyLead" : "Disqualifier le prospect",
      "showHideFields" : "Afficher/Masquer les champs",
      "jumpTo" : "Aller à",
      "redirectToUrlSubText" : "redirection des rendez-vous utilisateur après l'envoi",
      "displayCustomMessageSubText" : "messager en fonction des informations en fonction des informations",
      "disqualifyLeadSubText" : "filtrer les entrées sous des conditions précises",
      "showHideFieldsSubText" : "modifier un champ dynamique",
      "openBelowUrl" : "Ouvrir l’URL ci-dessous",
      "showCustomMessage" : "Afficher un message personnalisé",
      "alertConditionDelete" : "Voulez-vous vraiment supprimer cette condition ?",
      "deleteCondition" : "Supprimer la condition",
      "conditionExecutedMessage" : "Les conditions seront exécutées en suivant l’ordre descendant.",
      "allOperationOptions" : {
        "isEqualTo" : "Est égal à",
        "isNotEqualTo" : "N’est pas égal à",
        "contains" : "Contient",
        "doesNotContain" : "Ne contient pas",
        "startsWith" : "Commence par",
        "endsWith" : "Se termine par",
        "isEmpty" : "Est vide",
        "isFilled" : "Est rempli",
        "before" : "Avant",
        "after" : "Après",
        "greaterThan" : "Supérieur à",
        "lessThan" : "Moins que",
        "between" : "Entre",
        "isChecked" : "Est cochée",
        "isNotChecked" : "N'est pas vérifié"
      },
      "logic" : {
        "if" : "Si",
        "then" : "Puis",
        "and" : "Et",
        "or" : "Ou"
      },
      "phoneAlertMessage" : "Pour rechercher des numéros de téléphone avec un indicatif de pays, vous devez inclure explicitement le symbole « + » dans votre requête de recherche.",
      "deleteAlertMessage" : "Voulez-vous vraiment supprimer ce champ ? La condition associée à ce champ sera également supprimée.",
      "deleteField" : "Supprimer le champ",
      "jumpToDescription" : "Passez à une diapositive spécifique lorsque les conditions sont remplies",
      "cycleError" : "Impossible d'enregistrer. Boucle détectée entre {a} et {b}",
      "jumpToSlide" : "Aller à la diapositive",
      "submitSurvey" : "Enregistrer le sondage",
      "pageTitle" : "P{index} - {title}",
      "selectSlideToJumpTo" : "Sélectionnez la diapositive à partir de laquelle sauter",
      "selectedSlide" : "Diapositive sélectionnée",
      "typeValueHere" : "Veuillez saisir une valeur ici",
      "field" : "Champ",
      "slide" : "Diapositive",
      "selectFieldOrSlide" : "Sélectionner un secteur ou glisser",
      "selectFieldState" : "Sélectionner l’état du champ",
      "selectField" : "Sélectionner un champ",
      "selectOption" : "Sélectionner une option",
      "jumpToTarget" : "Aller à",
      "jumpToQuestion" : "Aller à la Question",
      "chooseQuestion" : "Choisir une question",
      "includeStart" : "Inclure démarrer",
      "includeEnd" : "Inclure la fin",
      "includeValue" : "Incluez {value}",
      "hideField" : "Masquer le champ",
      "hideFields" : "Masquer les Champs",
      "showField" : "Afficher le champ",
      "showFields" : "Afficher les champs",
      "additionalRulesPrefix" : "... et",
      "additionalRulesSuffix" : "autres règles {ifLabel} ...",
      "shownTargetsWithMore" : "{shown}, +{count} de plus",
      "noConditionsAlt" : "Aucune condition pour le moment",
      "outcomeLabels" : {
        "show" : "Afficher",
        "jumpTo" : "Aller à"
      }
    },
    "minimizedTitlePlaceholder": "Titre réduit",
    "dragYourElementFromLeft": "Faites glisser vos éléments ici à partir de la gauche",
    "formNotification": "Notification du formulaire",
    "sendSubmissionsAsPdf": "Transmettre l'envoi de formulaire au format PDF",
    "style": {
      "formPadding": "Marge intérieure du formulaire"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Intégrer ou partager le formulaire",
      "share" : {
        "openFormLink" : "ouvrir le lien du Formulaire"
      },
      "email" : {
        "emailSubheader" : "Créez un e-mail vide et remplissez votre formulaire, sans le fournir."
      }
    },
    "choosePosition": "statut",
    "testBuild": "Version de test"
  },
  "quiz" : {
    "quizElement" : "Élément de quiz",
    "quizNotification" : "Notification de quiz",
    "viewAndCustomise" : "Afficher et personnaliser",
    "categoryAndScore" : "Catégorie et score",
    "provideFeedback" : "Fournir des commentaires",
    "addQuizElement" : "Ajouter un élément de quiz",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "ajouter des questions",
    "dragAndDropQuestion" : "tirer glisser un élément de question ici.",
    "addNewPage" : "Nouveau page",
    "editTemplate" : "Modifier le Modèle",
    "editResultPage" : "Modifier la Page de Résultats",
    "clonePage" : "Cloner la page",
    "category" : {
      "category" : "catégorie",
      "watchVideo" : "Affichage de ce vidéo0000",
      "useCategoryWhen" : "Utilisez des catégories quand",
      "manageCategories" : "gérer les catégories",
      "howItWorks" : "Comment fonctionne ce travail ?",
      "howItWorks2" : "Comment fonctionne ce travail",
      "addCategoryMessage" : "ajouter une Nouveau catégorie",
      "assignCategoryMessage" : "Assigner une catégorie à chaque option",
      "editResultsMessage" : "Affichage du score in pagecatégorie",
      "addCategory" : "ajouter une catégorie",
      "deleteCategoryAlertMessage" : "La suppression d'une catégorie entraînera le retour de cette catégorie in chaque options",
      "editOrAddNewCategories" : "Vous pouvez modifier ou ajouter de nouvelles catégories",
      "toEvaluateTheResponder" : "Pour comparer le correspondant en fonction de plusieurs facteurs",
      "showMultipleCategoryScore" : "Affichage de plusieurs résultats in page",
      "displayVaryingContent" : "Affichage de la page de résultats en fonction de la personne",
      "theOptionFieldIsRequired" : "Le champ option est obligatoire",
      "addManage" : "ajouter / gérer",
      "enterCategoryPlaceholder" : "Saisissez le nom de la catégorie",
      "carouselAlt" : "Diapositive d'aperçu de catégorie"
    },
    "quizSettings" : "Paramètres du quiz",
    "onQuizSubmission" : "Envoi dans le quiz",
    "settings" : "Paramètres",
    "deletePage" : "Supprimer la page",
    "quizResult" : {
      "resultTemplate" : "Modèle de résultat",
      "quizResultAlertMessage" : "La page de résultats choisie s'affichera une fois le quiz terminé",
      "overallScoreLabel" : "Score global"
    },
    "autoResponderSubheader": "Envoi d’un e-mail automatisé à la personne qui soumet le formulaire (l’e-mail contient une copie des informations qu’elle a saisies dans le formulaire)",
    "sendSubmissionsAsPdf": "Transmettre l'envoi de quiz au format PDF",
    "sendQuizResultsAsPdf": "Transmettre le résultat du quiz au format PDF",
    "integrateHeader": "Intégrer le quiz",
    "integrateSubHeader": "Utilise les options suivantes pour intégrer votre quiz personnalisé dans votre site web",
    "integrateCopyLinkMessage": "Copiez le lien ci-dessous et partagez-le facilement où vous le souhaitez.",
    "pageLabel": "Page {n}",
    "pageName": "Nom de la page",
    "pagePosition": "Position de la page",
    "createContactOnPartialSubmissionSubText": "Crée un contact lorsqu'un utilisateur clique sur « Suivant » sur n'importe quelle diapositive, même s'il ne termine pas le quiz.",
    "integratePopup": {
      "shareOrEmbed": "Intégrer ou partager le quiz",
      "share": {
        "openFormLink": "ouvrir le lien du quiz"
      },
      "email" : {
        "emailSubheader" : "Créez un e-mail vide et votre quiz, sans le fournir."
      }
    }
  },
  "textEditor": {
    "textAlign": "Alignement du texte",
    "list": "Liste",
    "sourceCode": "Code source",
    "resetStyle": "Réinitialiser le style",
    "resetDocumentStyle": "Réinitialiser le style du document"
  }
}
